import React from "react"
import * as queryString from "query-string";
import SEO from "../components/seo";
import LayoutForm from "../components/Form/layoutForm";

const IndexPage = ({location}) => {
  return (
    <>
      <LayoutForm
        pageDetail={{
          type: "TravelPreference",
          contentIndex: 2,
          searchBar: false,
          gridName: "GridTravelPreference",
          cardClass: "CardCircle",
          imageClass: "ImageCircle",
          buttonClass: "Circle",
          buttonType: "Default",
          buttonNext: "/travelled-places",
          completed: 0,
          urlParam: queryString.parse(location.search),
        }}
      >
        <SEO title="My Travels"/>
      </LayoutForm>
    </>
  )
}

export default IndexPage
